import { useEffect } from "react";
import { BaseRetorikConfig } from "../configs/retorikConfig";
import { useAmn } from "../contexts/AmnContext"

const StorageHandler = () =>{
    const amn = useAmn();

    useEffect(()=>{
        if( localStorage.getItem("username") && 
            localStorage.getItem("dateStart") && 
            localStorage.getItem("conversationID")){
                let username = localStorage.getItem("username")!;
                let dateStart = new Date(JSON.parse(localStorage.getItem("dateStart")!));
                var now = new Date();
                //@ts-ignore
                var diffMs = (now - dateStart ); 
                var diffMins = Math.round(diffMs / 60000);
                console.log(diffMins);
                if(diffMins < 90){
                    //retreive conversation
                    amn.timer.retreive();
                    amn.setRetreiveConversation(true);
                }
                else{
                    localStorage.removeItem("username");
                    localStorage.removeItem("dateStart");
                    localStorage.removeItem("conversationID");
                    amn.timer.retreive(true);
                    amn.setRetreiveConversation(false);
                }
        }
        

        if(!localStorage.getItem("username") && !localStorage.getItem("dateStart")){
            //Set New User
            console.log("New user");
            let userName = BaseRetorikConfig.userData.name;
            let dateStart = new Date();
            localStorage.setItem("username",userName );
            localStorage.setItem("dateStart",JSON.stringify(dateStart));
        }

    }, [])


    return (<></>)
}

export {
    StorageHandler
}